import { FieldError } from 'react-hook-form';
import styled from 'styled-components';

interface IProps {
  error: FieldError | string;
}

export const FormErrorWrapper = styled.label`
  color: ${({ theme }) => theme.colors.dangerBtn};
  position: relative;
  font-size: 12px;
`;

const FormErrorView = ({ error }: IProps) => {
  if (!error) {
    return null;
  }

  const errorMsg = (error as FieldError).message || error;

  return <FormErrorWrapper>{errorMsg}</FormErrorWrapper>;
};

export default FormErrorView;
